var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.wrapper},[_c('v-data-table',{class:[_vm.$style.events_table],attrs:{"headers":_vm.headers,"items":_vm.events},scopedSlots:_vm._u([{key:"item.time",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.medium(new Date(item.time)))+" "),_c('span',{class:_vm.$style.time_formatted},[_vm._v(_vm._s(_vm.formatTime(new Date(item.time))))])]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }